import React from 'react';
import NumberDropdown from '../ui/NumberDropdown';
import { useTranslation } from 'react-i18next';
import { submitHelp } from '../../services/helpApi';

const ContactForm = () => {
  const { t } = useTranslation();
  const [form, setForm] = React.useState({
    name: '',
    email: '',
    phone: '',
    countryCode: '',
    message: '',
  });
  const [submitting, setSubmitting] = React.useState(false);
  const [status, setStatus] = React.useState({ ok: null, msg: '' });

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus({ ok: null, msg: '' });
    try {
      await submitHelp(form);
      setStatus({ ok: true, msg: 'Thanks! We will get back to you shortly.' });
      setForm({ name: '', email: '', phone: '', countryCode: '', message: '' });
    } catch (err) {
      setStatus({ ok: false, msg: err.message || 'Submission failed' });
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div className="bg-[#F6F6F6] sm:min-w-[500px] lg:max-w-[600px] w-full pt-[33px] pb-[33px] sm:pb-10 px-2.5 sm:px-6">
      <form
        onSubmit={onSubmit}
        className="max-w[500px] w-full mx-auto space-y-6"
      >
        <div className="w-full space-y-3">
          <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
            {t('contactForm.nameLabel')}
          </label>
          <input
            name="name"
            value={form.name}
            onChange={onChange}
            required
            type="text"
            placeholder={t('contactForm.namePlaceholder')}
            className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
          />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-2">
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('contactForm.emailLabel')}
            </label>
            <input
              name="email"
              value={form.email}
              onChange={onChange}
              required
              type="email"
              placeholder={t('contactForm.emailPlaceholder')}
              className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
            />
          </div>
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('contactForm.phoneLabel')}
            </label>
            <div className="flex gap-1 items-stretch">
              <NumberDropdown />
              <input
                name="phone"
                value={form.phone}
                onChange={onChange}
                type="text"
                placeholder={t('contactForm.phonePlaceholder')}
                className="bg-[#0000001A] w-full px-5 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
              />
            </div>
          </div>
        </div>
        <div className="w-full space-y-3">
          <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
            {t('contactForm.messageLabel')}
          </label>
          <textarea
            name="message"
            value={form.message}
            onChange={onChange}
            required
            placeholder={t('contactForm.messagePlaceholder')}
            className="h-[141px] resize-none bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
          />
        </div>

        <button
          type="submit"
          disabled={submitting}
          className="bg-[#000000] w-full py-5 text-white text-[13px] leading-[14px] uppercase font-medium"
        >
          {submitting ? 'Submitting...' : t('contactForm.submit')}
        </button>
        {status.msg && (
          <p
            className={`text-sm ${status.ok ? 'text-green-600' : 'text-red-600'}`}
          >
            {status.msg}
          </p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
